export default {
    en: {
        currencyFormat: {
            style: "currency",
            currency: "USD"
        }
    },
    ro: {
        currencyFormat: {
            style: "currency",
            currency: "RON"
        }
    }
}